import React, { useCallback, useEffect, useState } from 'react'
import { Header, Icon, ItemMeta } from 'semantic-ui-react'
import './deliveryTerms.css'
import { useDispatch, useSelector } from 'react-redux'
import { getSearchDropdownValues } from '../../../api/getGBForm'
import { updateTransportationHeaderInfo } from '../../../actions'
import { useEvent } from '../../../hooks/useEvent'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType';
import { validation } from '../../../util/cdsFieldPatterns';
import {addHeaderTabWarnings,deleteHeaderTabWarnings} from "../../../actions/errorValidationActions";
import { useDebounce } from '../../../../hooks'
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { goodsLocation } from '../../../util/cdsFieldPattern'

export default function GoodsLocationField(props) {
  const { isImportShipment, fieldPattern, validateError} = props
  const dispatch = useDispatch()
  const { locationOfGoods } = useSelector((state) => state.Shipment.transportation)
  const locationOfGoodErr = useSelector(state=>state.ValidationErrors?.header?.[goodsLocation]?.msg)

  const [goodLocList, setLocationList] = useState([])
  const { saveForm } = useEvent('header', true)
  const saveData = (params) => saveForm({ transportation: params })
  const {declarationCat = ''} = useSelector((state) => state.Shipment) || []
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'headerTab'),
    [declarationCat]
  )

 const addErrors = (level, value, fieldName) => {
   dispatch(addHeaderTabWarnings(level, value, fieldName))
 }
 const deleteErrors = (level, value, fieldName) => {
   dispatch(deleteHeaderTabWarnings(level, value, fieldName))
 }

 const getErrorMessage = useCallback((key,value,flag=false)=>{
  return getValidationError(key, value,flag) || []
},[locationOfGoods])

const item = React.useMemo(()=>{

  return goodLocList.find(item=>item.portFreightCode===locationOfGoods)
  
},[locationOfGoods,goodLocList])

 const handleClick = ()=>{
  let value=' '
  dispatch(updateTransportationHeaderInfo({ fieldName: 'locationOfGoods',value  }))
  saveData({
    locationOfGoods: value
  })
  if(isImportShipment)
  {let err = getValidationError('locationOfGoods', value,true)
                err.length
                  ? addErrors('headerTab', err[0], 'locationOfGoods')
                  : deleteErrors('headerTab', '', 'locationOfGoods')}
                  else {
                  validateError({[`${goodsLocation}`]:'',declarationCat:''},
              {transportation:{locationOfGoods:value},declarationCat:declarationCat},
              {[`${goodsLocation}`]:fieldPattern()?.header[goodsLocation],declarationCat:fieldPattern()?.header.declarationCat})}

 }

  const getLocationOfGoodsDropdownValues = useCallback(
    async (value) => {
      let payload = {
        eventType: 'GET_ENTITY_LIST',
        searchFilter: value,
        entityType: 'UK_FREIGHT_LOC',
        condition: 'GB',
        countryOfDestination: 'GB',
        type: 'CDS'
      }
      let response = await getSearchDropdownValues(payload)
      response = response?.data?.eventMessage?.ports?.list || []
      setLocationList(response)
    },
    [locationOfGoods]
  )  

  const currShipData = useCurrentShipmentType();
  const {isDisabled} = currShipData || {}

  const debouncedValue = useDebounce(locationOfGoods,1000)
  useEffect(()=>{
    getLocationOfGoodsDropdownValues(debouncedValue)
  },[debouncedValue])

  const createLOGString = (item) =>{
    let res= item?.portBadgeCodes || '';
    if(res){
      res=res+'-'
    }
   return res+`${item?.portFreightCode}-${item?.portName}`
   

  }

  return (
    <>
      <div className='unlc-div'>
      <label id="destinationCountrylabel" for="floatField" className="label-dropdown name-label es">{
        (isImportShipment?getErrorMessage("locationOfGoods",locationOfGoods,true)?.length>0 : locationOfGoodErr) &&

        <PopUpIcon 
                            className="errorIcon"
                            color="red" icon="warning sign"
                            popupText={isImportShipment ?getValidationError("locationOfGoods",locationOfGoods,true):locationOfGoodErr}
                           />}<div className="ui black label input-box-number">5/23</div>Location of Goods</label>
        <input
         style={{marginTop:'2px'}}
          onChange={(e) => {
            let value = e.target.value;
            dispatch(updateTransportationHeaderInfo({ fieldName: 'locationOfGoods', value }))
          }}
          list='goodsLocList'
          name='goodsLoc'
          value={locationOfGoods}
          errors={isImportShipment ? getValidationError("locationOfGoods",locationOfGoods||' ',true) : locationOfGoodErr}
          id='locationOFGoods'
          disabled={isDisabled}
          onBlur={(e) => {
            let value = e.target.value
            saveData({
                locationOfGoods: value || ' '
              })
              
              validateError({[`${goodsLocation}`]:'',declarationCat:''},
              {transportation:{locationOfGoods:value},declarationCat:declarationCat},
              {[`${goodsLocation}`]:fieldPattern()?.header[goodsLocation],declarationCat:fieldPattern()?.header.declarationCat})

              let err = getValidationError('locationOfGoods', locationOfGoods,true)
                err.length
                  ? addErrors('headerTab', err[0], 'locationOfGoods')
                  : deleteErrors('headerTab', '', 'locationOfGoods')
          }}
        />
        <datalist id='goodsLocList'>
          {goodLocList.length > 0 &&
            goodLocList.map((item) => (
              <option
                key={item.portFreightCode}
                value={item.portFreightCode}
              >{createLOGString(item)}</option>
            ))}
        </datalist>
        { locationOfGoods?.trim() && <Icon
        disabled={isDisabled}
        style={{marginTop:'15px',cursor:'pointer'}}
        color='grey' name='close'
        onClick={handleClick}

       /> }
       <div style={{display:'flex',flexDirection:'column'}}>
         <Icon
          name={'search'} 
          color='grey'
          className='unlc-search' />
          {locationOfGoods && item && <PopUpIcon  popupStyle={{maxWidth:'600px',minWidth:'100px'}} style={{marginBottom:'10px',marginLeft:'5px'}} icon="info circle"  popupText={
          <>
          <ul><li style={{marginBottom:'5px'}}><Header size='medium'>{locationOfGoods}</Header></li><li><Header size='small'>{createLOGString(item)}</Header></li></ul>
          </>
        
          } />
        }
       </div>
      </div>
    </>
  )
}

